import script from "./FormEmailSendPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./FormEmailSendPanel.vue?vue&type=script&setup=true&lang=js"

import "./FormEmailSendPanel.vue?vue&type=style&index=0&id=027755df&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-027755df"]])

export default __exports__